/* eslint-disable */
import React from "react";
import cross from "../../Assests/Globalimages/cross.png";
import Navbar from "../../Componenets/Navbar";
import Footer from "../../Componenets/Footer";
import { useSelector, useDispatch } from "react-redux";
import { removeFromCart, increaseQuantity, decreaseQuantity } from "../../Redux/cartSlice";
import {updateCart_db , removeFromCart_db} from '../../Redux/db_Cart/db_cartSlice'
import { useNavigate } from "react-router-dom";
import { imageUrl } from "../../Config";
import { useEffect } from "react";
import {getCartItems_db} from '../../Redux/db_Cart/db_cartSlice'


const CartPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cartItems = useSelector((state) => state.cart.cartItems);
  const { dbCartItems } = useSelector((state) => state.db_cart);
  const login = localStorage.getItem("token");

  useEffect(()=>{
    dispatch(getCartItems_db())
  },[])

  const getTotal = () => {
    let total = 0;
    const items = login ? dbCartItems : cartItems;
    items.forEach((item) => {
      total += parseFloat(login ? item?.Product?.price : item?.price) * item.quantity;
    });
    return total.toFixed(2);
  };


  const handleIncrese = (item)=>{
    if(login){
      dispatch(updateCart_db({productId : item?.Product.id , quantity : item?.quantity+1}))
    }else{
      dispatch(increaseQuantity(item?.id))
    }

  }
  const handleDecrease = (item)=>{
      if(item?.quantity == 1){
        return
      }
    if(login){
      dispatch(updateCart_db({productId : item?.Product.id , quantity : item?.quantity-1}))
    }else{
      dispatch(decreaseQuantity(item?.id))
    }
  }

 const handleRemoveFromCart = (item)=>{
  if(login){
    dispatch(removeFromCart_db(item?.Product?.id))
  }
  else{
    dispatch(removeFromCart(item?.id))
  }
 }

  const displayedCart = login ? dbCartItems : cartItems;

  return (
    <div>
      <section className="shope-now-section">
        <div className="container">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-lg-8">
              <div className="content-shop-now text-center">
                <h3>Pure Bliss Awaits</h3>
                <h1>Add Handmade Soaps to Your Cart</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="productprice">
  <div className="container">
    <div className="row">
      <div className="col-12 col-lg-8">
        <div className="content-product-price">
          <div
            className="product-header d-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr 1fr",
              textAlign: "center",
              fontWeight: "bold",
              padding: "15px 0 5px",
              borderBottom: "2px solid #ddd",
            }}
          >
            <h2 style={{ fontSize: "16px" }}>Product</h2>
            <h2 style={{ fontSize: "16px" }}>Price</h2>
            <h2 style={{ fontSize: "16px" }}>Quantity</h2>
            <h2 style={{ fontSize: "16px" }}>Subtotal</h2>
          </div>

          {displayedCart.map((item, index) => (
            <div
              key={index}
              className="product-row d-grid"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr 1fr",
                textAlign: "center",
                alignItems: "center",
                padding: "10px 0",
              }}
            >
              <div
                className="d-flex align-items-center gap-3"
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <img
                  onClick={() => handleRemoveFromCart(item)}
                  src={cross}
                  className="img-fluid cross"
                  alt=""
                  style={{ cursor: "pointer", width: "20px", height: "20px", paddingLeft:3 }}
                />
                <img
                  src={login ? imageUrl + item?.Product?.imageUrl : imageUrl + item?.imageUrl}
                  className="img-fluid"
                  alt=""
                  style={{ height: "75px", width: "50px" }}
                />
                <h6 style={{ fontSize: "14px", margin: "0" }}>
                  {login ? item?.Product?.name : item.name}
                </h6>
              </div>

              <h4 style={{ fontSize: "14px" }}>${login ? item?.Product?.price : item.price}</h4>

              <div
                className="d-flex align-items-center justify-content-center"
                style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
              >
                <div
                  className="minus-soap"
                  onClick={() => handleDecrease(item)}
                  style={{ cursor: "pointer", fontSize: "18px", padding: "5px" }}
                >
                  <i className="fas fa-minus"></i>
                </div>
                <div className="quantity mx-2" style={{ fontSize: "16px", margin: "0 10px" }}>
                  {item.quantity}
                </div>
                <div
                  className="plus-soap"
                  onClick={() => handleIncrese(item)}
                  style={{ cursor: "pointer", fontSize: "18px", padding: "5px" }}
                >
                  <i className="fas fa-plus"></i>
                </div>
              </div>

              <h4 style={{ fontSize: "14px" }}>
                ${(parseFloat(login ? item?.Product?.price : item?.price) * item.quantity).toFixed(2)}
              </h4>
            </div>
          ))}
        </div>
      </div>

     
      <div className="col-12 col-lg-4 mt-4 mt-lg-0">
        <div
          className="content-product-card"
          style={{
            background: "#f8f9fa",
            padding: "20px",
            // borderRadius: "8px",
            textAlign: "center",
          }}
        >
          <div className="card-total">
            <h4 style={{ fontWeight: "bold", fontSize: "18px" }}>Cart Totals</h4>
          </div>
          <div className="main-card">
            <div
              className="sub-total d-flex justify-content-between"
              style={{
                fontSize: "16px",
                padding: "10px 0",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <h5 style={{ margin: "0" }}>Total</h5>
              <h5 style={{ margin: "0" }}>${getTotal()}</h5>
            </div>
            <div className="card-border" style={{ borderBottom: "1px solid #ddd", margin: "10px 0" }}></div>
            <div className="btn-card-product mt-4">
              <button
                disabled={displayedCart.length === 0}
                onClick={() => navigate('/checkout')}
                className="proceed-to-checkout"
             
              >
                Proceed to Checkout
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

      <Footer/>
    </div>
  );
};

export default CartPage;
